import { render, staticRenderFns } from "./AdminBulkEditNodeDefs.vue?vue&type=template&id=20384fe0&scoped=true"
import script from "./AdminBulkEditNodeDefs.vue?vue&type=script&lang=ts"
export * from "./AdminBulkEditNodeDefs.vue?vue&type=script&lang=ts"
import style0 from "./AdminBulkEditNodeDefs.vue?vue&type=style&index=0&id=20384fe0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20384fe0",
  null
  
)

export default component.exports